//KRP1107
(function () {

    function funcReady() {
        $('.KRP1107').buildCommonUI();

        var KRP1107 = {
            init: function() {
                var self = this;

                self.setting();
                self.bindEvents();
                self.bindAccEvents(); //BTOCSITE-77514 > WA 전문가점검 > 6. 장바구니 -> 안내 메시지 -> 초점초기화


                vcui.require(['ui/carousel'], function () {
                    // 컴포넌트가 다중인경우 처리
                    self.$component.each(function() {
                        self.requestListData(this);
                    })
                })
            },
            setting: function() {
                var self = this;

                self.$component = $('.component.KRP1107');
                self.$carousel = self.$component.find('.component-product__carousel');
                self.$nodata = self.$component.find('.nodata-wrap');
                self.$productItem = self.$carousel.find('.component-product__item');
                self.$btnCart = self.$productItem.find('.item__button--cart');

                self.$btnAllview = self.$component.find('.component-header__button');
                self.$allViewPop = $('.relative-prod-view');
                self.$allViewContent = self.$allViewPop.find('.pop-conts');
                self.$allViewCount = self.$allViewPop.find('.product-list__total .count');
                self.$sort = self.$allViewPop.find('.product-list__sort .ui_selectbox');
                self.$allViewPrdList = self.$allViewPop.find('.product-list');
                self.hiddenData = self.$allViewPop.find('.hidden-input-group');
                self.viewScrollFlag = true;
                self.listTemplate =
                    '{{#each item in itemList}}' +
                    '<div class="slide-conts ui_carousel_slide component-product__item {{#if item.temporarySellFlag == "Y"}}is-soldout{{/if}}">' +
                    '    <div class="component-product__item-wrap">' +
                    '       <a href="{{item.modelUrlPath}}" class="item-link">' +
                    '            <div class="item__image">' +
                    '                <div class=item__image-wrap><img src="{{item.mediumImageAddr}}" alt=""></div>' +
                    '            </div>' +
                    '            <div class="item__infos">' +
                    '                <div class="item__name">{{item.modelDisplayName}}</div>' +
                    '                <div class="item__sku">{{item.modelName}}</div>' +
                    '            </div>' +
                    '        </a>' +
                    '{{#if item.checkBtnFlag}}' +
                    '        <div class="item__price-wrap">' +
                    '            <em class="blind">판매가격</em>' +
                    '            <span class="item__price">{{item.currentPrice}}<em>원</em></span>' +
                    '            {{#if item.temporarySellFlag == "Y"}}<span class="item__price-soldout">일시품절</span>{{/if}}' +
                    '        </div>' +
                    '{{/if}}' +
                    '        <div class="item__button-wrap">' +
                    '            <button class="item__button--cart" data-id="{{item.modelId}}" data-model-name="{{item.modelName}}" data-sku="{{item.modelSku}}" data-type-flag="{{item.bizType }}" data-require-care="{{item.careshipOnlyFlag}}" data-contents="{{item.modelDisplayName}} "><span class="blind">장바구니 담기</span></button>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>' +
                    '{{/each}}';

                self.viewTemplate =
                    '{{#each (item, idx) in listData}}' +
                    '<li class="product-item {{#if item.temporarySellFlag == "Y"}}is-soldout{{/if}} {{#if idx < 20}}is-active{{/if}}">' +
                    '    <a href="{{item.modelUrlPath}}" class="item-box">' +
                    '        <div class="product-item__thumb"><img src="{{item.mediumImageAddr}}" alt=""></div>' +
                    '        <div class="product-item__infos">' +
                    '            <div class="product-item__category">' +
                    '               {{#if item.superCategoryName}}<span>{{item.superCategoryName}}</span>{{/if}}' +
                    '               {{#if item.categoryName}}<span>{{item.categoryName}}</span>{{/if}}' +
                    '               {{#if item.subCategoryName}}<span>{{item.subCategoryName}}</span>{{/if}}' +
                    '            </div>' +
                    '            <div class="product-item__name">{{item.modelDisplayName}}</div>' +
                    '            <div class="product-item__sku">{{item.modelName}}</div>' +
                    '            <div class="product-item__price">' +
                    '               {{#if item.salePercent > 0}}<span class="discount"><em class="blind">할인율</em>{{item.salePercent}}%</span>{{/if}}' +
                    '{{#if item.obsOriginalPrice != item.obsSellingPrice}}' +
                    '                <div class="current-price"><em class="blind">할인가</em>{{item.salesPrice}}<span>원</span></div>  ' +
                    '                <div class="origin-price"><em class="blind">할인 전 가격</em>{{item.originPrice}}<span>원</span></div>  ' +

                    '{{#else}}' +
                    '                <div class="current-price"><em class="blind">할인 전 가격</em>{{item.originPrice}}<span>원</span></div>  ' +
                    '{{/if}}' +
                    '                {{#if item.temporarySellFlag == "Y"}}<span class="soldout">일시품절</span>{{/if}}' +
                    '            </div>' +
                    '        </div>' +
                    '    </a>' +
                    '</li>' +
                    '{{/each}}';
            },

            bindEvents: function() {
                var self = this;
                //상품 리스트 장바구니
                self.$carousel.on('click', '.item__button--cart', function(e){
                    e.preventDefault();

                    var typeflag = $(this).attr('data-type-flag');
                    var sendflag = (typeflag == "PRODUCT" || typeflag == "DISPOSABLE") ? "P" : "C";

                    if(!$(this).hasClass('disabled')){
                        var $this = $(this);
                        var param = {
                            "id":$this.attr('data-id'),
                            "sku":$this.attr('data-sku'),
                            "rtSeq":$this.attr('data-rtSeq'),
                            "typeFlag": sendflag
                        }
                        var ajaxUrl = $this.closest('.component.KRP1107').attr('data-cart-url');
                        lgkorUI.requestCart(ajaxUrl, param, true);
                    }
                });

                //소모품 전체보기 버튼
                self.$component.on('click', '.component-header__button', function(e){
                    var $this = $(this);
                    var popupId = $this.data('modal');
                    var currentModel = $this.data('modelId');
                    var hiddenModel = $this.data('hideModelId');

                    e.preventDefault();

                    $(popupId).data({modelId: currentModel, hideModelId: hiddenModel});
                    $(popupId).find('.product-list__sort .ui_selectbox').vcSelectbox('selectedIndex', 0);
                    $(popupId).vcModal({opener: this})
                })

                //팝업 열기: 열릴 때 데이터 최초 실행
                self.$allViewPop.on('modalshow', function(e,data){
                    console.log("modalshow %o",e)
                    self.clearViewList(e.target)
                    self.requestAllViewData(e.target)
                })


                //팝업 닫기: 닫일때 데이터 초기화
                self.$allViewPop.on('modalhidden', function(e){
                    self.clearViewList(e.target);
                    self.clearViewData(e.target)
                    self.clearViewSort(e.target);
                })

                //전체보기 팝업 셀렉트
                self.$sort.on('change', function(e){
                    var $allViewPop = $(this).closest('.relative-prod-view');
                    if($allViewPop.is(':visible')) {
                        self.clearViewList($allViewPop);
                        self.requestAllViewData($allViewPop)
                    }
                })

                //전체보기 팝업 스크롤시 추가 목록 불러오기
                self.$allViewContent.on('scroll', function(e){
                    var $this = $(this);
                    var $allViewPop = $this.closest('.relative-prod-view');
                    var scrollTop = $this.scrollTop();
                    var height = $allViewPop.height() - $allViewPop.find('.pop-header').height();

                    if(!self.viewScrollFlag) {
                        return;
                    }

                    if( scrollTop + height >= this.scrollHeight * 0.8) {
                        self.viewScrollFlag = false;
                        vcui.throttle(self.showMoreList($allViewPop), 100)
                    }
                })
            },
            //BTOCSITE-77514 > WA 전문가점검 > 6. 장바구니 -> 안내 메시지 -> 초점초기화
            bindAccEvents: function() {
                var self= this;
                var $addCartBtn = null;
                self.$carousel.on('click', '.item__button--cart', function(e){
                    $addCartBtn = $(e.target);
                })
                $(window).on('toastclose',function(e,obj){
                    if($addCartBtn != null){
                        setTimeout(function(){
                            $addCartBtn != null && $addCartBtn.focus();
                            $addCartBtn = null;
                        },300)
                    }
                }).on('modalhide',function(e,obj){
                if($addCartBtn != null){
                        setTimeout(function(){
                            $addCartBtn != null && $addCartBtn.focus();
                            $addCartBtn = null;
                        },300)
                    }
                });
            },
            carousel: function($carousel){
                var self = this;

                var $carousel = $carousel || self.$carousel;
                $carousel.each(function(){
                    var $slider = $(this);
                    if($slider.hasClass('is-active') && isSetCarousel === false) {
                        $slider.vcCarousel({
                            infinite: false,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                            swipeToSlide: true,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            arrows: true,
                            // dotsSelector: '.ui_carousel_dots',
                            touchThreshold: 100,
                            cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                            speed: 150,
                            responsive: [
                                {
                                    breakpoint: 10000,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 4,
                                    }
                                },
                                {
                                    breakpoint: 1280,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 3,
                                    }
                                }
                            ]
                        });
                        if(window.innerWidth < 768) {
                            $slider.vcCarousel('instance').name == 'Carousel' && $slider.vcCarousel('destroy');
                        }
                    }
                });
            },
            showMoreList: function(popup){
                var self = this;
                var $allViewPrdList =  $(popup).find('.product-list');

                if( $allViewPrdList.find('.product-item').not('.is-active').length == 0) return;

                var startIndex = $allViewPrdList.find('.product-item.is-active').last().index() + 1;
                var endIndx = startIndex + 20;

                $allViewPrdList.find('.product-item').slice(startIndex, endIndx).addClass('is-active');

                self.viewScrollFlag = true;
            },
            clearViewList: function(target){
                var self = this;
                var $allViewPrdList =  $(target).find('.product-list');
                $allViewPrdList.empty();
            },
            clearViewSort: function(target){
                var self = this;
                var $allViewPop   = $(target);
                var $allViewCount = $allViewPop.find('.product-list__total .count');
                $allViewCount.text(0);
            },
            clearViewData: function(target){
                var self = this;
                var $allViewPop = $(target);
                $allViewPop.data({modelId: "", hideModelId: ""}).find('.pop-header .tit span').text('연관 소모품');
            },
            requestListData: function(el){
                var self = this;
                var $component = $(el);
                var $carousel    = $component.find('.component-product__carousel');
                var $nodata     = $component.find('.nodata-wrap');
                var $btnAllview = $component.find('.component-header__button');
                var ajaxUrl = $component.data('ajaxUrl');
                var param = {};

                if($component.length === 0) return;
                if( ajaxUrl == "" || ajaxUrl == undefined) return;

                param = {
                    modelId: $component.data('modelId'),
                    modelGubun: $component.data('modelGubun'),
                    modelCode : $component.data('modelCode')
                }

                lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                    if( result && result.status == 'success') {
                        var resultData = result.data[0].consumables;
                        if(resultData.length > 0) {
                            resultData.forEach(function(item) {
                                item.currentPrice = vcui.number.addComma(item.obsSellingPrice)
                                item.modelUrlPath = self.getUrlKiosk(item.modelUrlPath);

                                var kiosk = lgkorUI.getParameterByName("kiosk");
                                if (lgkorUI.stringToBool(kiosk)) {
                                    item.checkBtnFlag = false;
                                } else {
                                    item.checkBtnFlag = true;
                                }
                            });
                            $carousel.addClass('is-active');
                            $btnAllview.attr('data-model-id', resultData[0].topModelId)

                            $carousel.find('.ui_carousel_track').empty().append(vcui.template(self.listTemplate, {itemList: resultData}));
                            self.carousel($carousel);

                            if(result.data[0].consumablesCount > 10) {
                                $btnAllview.addClass('is-active');
                            }
                        } else {
                            $nodata.addClass('is-active');
                        }
                    }
                });
            },
            requestAllViewData: function(target){
                var self = this;
                var $allViewPop     = $(target);
                var $sort           = $allViewPop.find('.product-list__sort .ui_selectbox');
                var $allViewCount   = $allViewPop.find('.product-list__total .count');
                var $allViewPrdList = $allViewPop.find('.product-list');
                var ajaxUrl = $allViewPop.data('ajaxUrl');
                var modelId = $allViewPop.data('modelId')
                var param = {};

                if( ajaxUrl == "" || ajaxUrl == undefined) return;

                param = {
                    'sortType': $sort.val(),
                    // 'hideModelId': hideModelId,
                    'modelId': modelId
                };

                lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                    if( result.status == 'success') {
                        var resultData = result.data;

                        if(resultData && resultData.length > 0) {
                            // if( hideModelId != undefined && hideModelId != "" ) {
                            //     self.$allViewPop.find('.pop-header .tit > span').text(resultData[0].topModelName + '의 소모품');
                            // }

                            resultData.forEach(function(item){
                                var percent = 0;
                                if( item.obsSellingPrice != item.obsOriginalPrice) {
                                    percent = Math.floor((item.obsOriginalPrice - item.obsSellingPrice)/item.obsOriginalPrice*100.0);
                                }
                                item.originPrice = vcui.number.addComma(item.obsOriginalPrice)
                                item.salesPrice = vcui.number.addComma(item.obsSellingPrice)
                                item.salePercent = percent;
                            })
                            $allViewCount.text(result.dataCount);
                            $allViewPrdList.append(vcui.template(self.viewTemplate, {listData: resultData}));

                        }
                        self.viewScrollFlag = true
                    }
                });
            },
            resize: function(){
                var self = this;

                self.carousel();
            },
            /**
             * @method getUrlKiosk
             * @param {url} [url : model url]
             * @return {myCallback}  [키오스크 url 값 return]
             */
            getUrlKiosk: function (url) {
                var kiosk = lgkorUI.getParameterByName("kiosk");
                if (lgkorUI.stringToBool(kiosk) && url.indexOf("kiosk=") === -1) {
                    url += url.indexOf("?") === -1 ? "?" : "&";
                    url += "kiosk=" + kiosk;
                }
                return url;
            },
        };
        KRP1107.init();

        var isSetCarousel = false;
        $(window).on('load',function(){
            isSetCarousel = false;
            KRP1107.resize();
            $(this).on('resizeend', function(){
                KRP1107.resize();
            }).on('scroll',function(){
                isSetCarousel = vcui.detect.isIOS;	// BTOCSITE-31024 확인
            }).on('scrollend',function(){
                isSetCarousel = false;
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CART', name: 'KRP1107', isFirstLoad: true, fn: function () {
                if(!document.querySelector('.KRP1107')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP1107')) return false;
        funcReady();
    });
})();